import React from "react";
import ReactDOM from "react-dom";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, } from "@material-ui/core";
import { useCreateEmployeeForm } from "frontend/src/domain/client-employees";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { queryClient } from "frontend/src/domain/query-client";
import { clientsCacheKey } from "frontend/src/domain/client/shared";
var AddEmployeeDialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, clientId = _a.clientId;
    var _b = useCreateEmployeeForm(clientId), name = _b.name, password = _b.password, submit = _b.submit, isLoading = _b.isLoading, isSuccess = _b.isSuccess;
    React.useEffect(function () {
        if (isSuccess) {
            queryClient.invalidateQueries(clientsCacheKey);
            onClose();
        }
    }, [isSuccess]);
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, fullWidth: true, maxWidth: "sm" },
        React.createElement("form", { onSubmit: submit },
            React.createElement(DialogTitle, null, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430"),
            React.createElement(DialogContent, null,
                React.createElement(TextField, { label: "Логин", fullWidth: true, value: name.value, onChange: name.onChange, autoFocus: true, error: Boolean(name.error), helperText: name.error }),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { label: "Пароль", fullWidth: true, type: "password", value: password.value, onChange: password.onChange, error: Boolean(password.error), helperText: password.error }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onClose, color: "primary" }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"),
                React.createElement(ButtonLoader, { isLoading: isLoading, color: "primary", type: "submit" }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C")))));
};
export var AddEmployee = function (_a) {
    var clientId = _a.clientId;
    var _b = React.useState(false), isOpen = _b[0], setOpen = _b[1];
    var open = function () { return setOpen(true); };
    var close = function () { return setOpen(false); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Button, { variant: "outlined", color: "primary", onClick: open }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C")),
        ReactDOM.createPortal(React.createElement(AddEmployeeDialog, { clientId: clientId, isOpen: isOpen, onClose: close }), document.body)));
};
